import { SignInPasswordlessConfirmationBase } from '@/app_components/SignIn/Confirmations/SignInPasswordlessConfirmationBase';

interface PasswordlessConfirmationProps {
  email: string;
}

export const SignInPasswordlessConfirmation = ({ email }: PasswordlessConfirmationProps) => {
  const headerText = 'Check your email to continue';
  const subheaderText = `A sign-in link is on its way to ${email}. Click it to finish signing in.`;

  return (
    <SignInPasswordlessConfirmationBase
      headerText={headerText}
      resendEmail={email}
      subheaderText={subheaderText}
    />
  );
};
